<template>
  <div class="card-inner">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CardInner"
}
</script>
